import React, { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import GeneralPageLayout from '../../../components/layout/GeneralPageLayout';
import { selectCurrentFlow } from '../../../store/slices/flow/flowSelectors';
import { useCloseWindow } from '../../../hooks/useCloseWindow';
import { eunaCancelPayment } from '../../../api/payment/payment';
import usePlaceNavigate from '../../../hooks/usePlaceNavigate';

const PaymentCancel = () => {
  const { search } = useLocation();
  const params = useMemo(() => new URLSearchParams(search), [search]);
  const currentFlow = useSelector(selectCurrentFlow);
  const { isAbleToCloseWindow, closeWindow } = useCloseWindow();
  const placeNavigate = usePlaceNavigate();

  useEffect(() => {
    const paymentId = params.get('payment_id');
    const webhookVerificationKey = params.get('webhook_verification_key');

    if (paymentId && webhookVerificationKey) {
      eunaCancelPayment(paymentId, webhookVerificationKey);
    }
  }, [params]);

  return (
    <GeneralPageLayout
      flow={currentFlow}
      next={
        (isAbleToCloseWindow && 'Close Window') || 'Restart Payment Process'
      }
      showNext
      onNext={
        isAbleToCloseWindow ? closeWindow : () => placeNavigate('/dashboard')
      }
    >
      <p>
        Your payment transaction has been cancelled. To retry the payment,
        return to the portal, and click the back button to restart the payment
        process.
      </p>
    </GeneralPageLayout>
  );
};

export default PaymentCancel;
